// 在这里注册活动组件
export default {
  1151: () => import('./ActComponent1'),
  1152: () => import('./ActComponent2'),
  1153: () => import('./ActComponent3')
};
